import { useEffect } from 'react';

import { matchInspector, usePathname } from './lib/router.js';
import { adoptLegacyRulesEndpoint } from './lib/storage.js';
import { Home } from './routes/Home.js';
import { Inspector } from './routes/Inspector.js';

export function App() {
  const pathname = usePathname();
  const slug = matchInspector(pathname);

  // The rules editor used to keep its own endpoint under its own key. Fold it
  // into the shared list once, so nobody who was using it loses a token.
  useEffect(() => {
    adoptLegacyRulesEndpoint();
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      {slug ? <Inspector key={slug} slug={slug} /> : <Home />}
    </div>
  );
}
